import { formatNotIncludedMessage } from '../../helpers/custom-population';
import type { NotIncludedStudents } from '../../helpers/custom-population';

import Icons from 'assets/icons';

interface NotIncludedWarningProps {
  students: NotIncludedStudents;
}

const NotIncludedWarning = ({ students }: NotIncludedWarningProps) => {
  const message = formatNotIncludedMessage(students);

  if (!message) return null;

  return (
    <p
      className="ml-auto flex items-center gap-1.5 text-right text-sm text-amber-700"
      role="status"
      data-testid="admit-not-included-warning"
    >
      <Icons.Warning className="size-4 shrink-0" aria-hidden="true" />
      {message}
    </p>
  );
};

export default NotIncludedWarning;
